import { createRouter, createWebHistory } from 'vue-router'
import routes from "@/config/routes";
import { AccessToken } from "@/utils/constant";

// 定义需要登录验证的路由名称
const needLoginRoutes = ['user', 'userProfile', 'settings']; // 添加需要登录才能访问的路由

const router = createRouter({
  history: createWebHistory(),
  routes: routes,
})

router.beforeEach((to, from) => {
  // 使用`to.meta.title`来获取目标路由的SEO标题
  if (to.meta.title) {
    document.title = to.meta.title; // 动态更新文档标题
  }
  const token = localStorage.getItem(AccessToken);

  // 如果目标路由在需要登录验证的列表中，但没有有效的token，则重定向到登录页面
  if (needLoginRoutes.includes(to.name) && !token) {
    return { name: 'login' };
  }

})

export default router;